module.exports = __webpack_public_path__ + "img/product_stkr_event.b30feeaf.svg";